/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Settings_RefusedInputs */



/**
* | output |
* | --- |
* | "The change was refused." |
*
* @param {Tenant_Settings_RefusedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const tenant_settings_refused = /** @type {((inputs?: Tenant_Settings_RefusedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Settings_RefusedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменение отклонено.")
	return /** @type {LocalizedString} */ ("The change was refused.")
});